import React, { Component } from 'react';
import { Table, Form, Row, Col, Input, Button, Section, Icon, Collapsible, CollapsibleItem, Carousel, Pagination, MenuItem, Dropdown } from 'react-materialize';
import Simulation from './Simulation';
import BigSimCsv from './BigSimCsv';
import BigSim from './BigSim';

class Simulations extends Component {
    constructor(props) {
        super();

        this.simMaps = {
            "Manual": function(three, hidden) { return (<row><Simulation three={three} hidden={hidden}/></row>); },
            "CSV": function(three, hidden) { return (<row><BigSimCsv three={three} hidden={hidden} /></row>); },
            "Percent Pattern": function(three, hidden) { return (<row><BigSim three={three} hidden={hidden} /></row>); }
        };
        this.state = {
            simI: 0,
            simNames: []
        };
    }

    render() {
        var simulations = [];
        for (var i = 0; i < this.state.simNames.length; i++) {
            var simTypeName = this.state.simNames[i].substring(0, this.state.simNames[i].indexOf(':'));
            console.log(simTypeName);
            if (this.state.simI == i) {
                simulations.push(this.simMaps[simTypeName](this.props.three, false));
            } else {
                simulations.push(this.simMaps[simTypeName](this.props.three, true));
            }
        }
        
        var simButtons = [];
        for (var simName in this.simMaps) {
            console.log("SIMNAME: ", simName);
            simButtons.push(<div><Button waves='light' s={2} onClick={((simName, evt) => {
                var newSimNames = this.state.simNames.slice();
                newSimNames.push(simName + ":Simulation #" + toString(this.state.simI));
                this.setState({
                    simNames: newSimNames
                });
            }).bind(this, simName)}>Add {simName} Sim</Button><br /><br /></div>);
        }
        
        return (
            <div class="card-panel grey lighten-5 z-depth-1">
                <Section>
                    <Row>
                        <Col offset={"s1"} s={4}>
                            <h3 s={12}><Icon small>bubble_chart</Icon>Simulations</h3>
                        </Col>
                    </Row>
                    <Row>
                        {simulations}
                    </Row>
                    <Row>
                        <Pagination items={this.state.simNames.length} activePage={this.state.simI + 1} maxButtons={8} onSelect={((val) => {
                            this.setState({simI: val - 1});
                        }).bind(this)}/>
                    </Row>
                    <Row>
                        {simButtons}
                    </Row>
                </Section>
            </div>
        );
    }
}

export default Simulations;


// WEBPACK FOOTER //
// ./src/Simulations.js